// extracted by mini-css-extract-plugin
export default {"content":"RecoverWarningModal_content__R8kAC"};